import { useState } from "react";
import { useParams } from "react-router";
import { useFetch } from "../hooks/useFetch";

type MeResponse = {
	user: { name: string };
	session: { impersonatedBy: string | null };
};

export function ImpersonationBanner() {
	const { workspaceSlug } = useParams<{ workspaceSlug: string }>();
	const { data } = useFetch<MeResponse>(`/api/tenant/${workspaceSlug}/me`);
	const [stopping, setStopping] = useState(false);

	if (!data?.session?.impersonatedBy) return null;

	async function handleStop() {
		setStopping(true);
		try {
			const res = await fetch(
				`/api/admin/tenants/${workspaceSlug}/impersonate/stop`,
				{
					method: "POST",
					credentials: "include",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({}),
				},
			);
			if (res.ok) {
				window.location.href = `/admin/tenants/${workspaceSlug}`;
			}
		} finally {
			setStopping(false);
		}
	}

	return (
		<div className="bg-amber-400 text-amber-900 px-4 py-2 text-sm font-medium flex items-center justify-between fixed top-0 left-0 right-0 z-50">
			<span>Impersonating as {data.user.name}</span>
			<button
				type="button"
				onClick={handleStop}
				disabled={stopping}
				className="px-3 py-1 text-xs rounded bg-amber-600 text-white hover:bg-amber-700 disabled:opacity-50"
			>
				{stopping ? "Stopping…" : "Stop Impersonating"}
			</button>
		</div>
	);
}
